export const SIM_CARDS = {
    COLLECTION: {
        url: '/simSubscriptions'
    },
    DETAILS: {
        url: '/simSubscriptions/:simSubscriptionUuid',
        queryKey: 'simCardDetails'
    },
    ACTIVATE: {
        url: '/sims/activate'
    },
    TERMINATE: {
        url: '/sims/terminate'
    },
    SUSPEND: {
        url: '/sims/suspend'
    },
    UPDATE: {
        url: '/sims/:simUuid'
    },
    REPLACE: {
        url: '/sims/:simUuid/replace'
    },
    PAYVIEW_OFFERS: {
        queryKey: 'getPayviewOffers',
        url: '/sims/sierraOffers'
    },
    STATUS: {
        url: '/sims/statusRequest'
    },
    ASSOCIATE: {
        url: '/sims/associate'
    },
    ADD_SIM_CARDS_FROM_ORDER_ID: {
        url: '/sims/sierraImportOrder'
    },
    REACTIVATE: {
        url: '/sims/reactivate'
    },
    FILE_ACTION: {
        url: '/sims/fileAction'
    },
    REASSIGN: {
        url: '/sims/reassign'
    },
    EXPORT: {
        url: '/sims/export'
    },
    SIM_PLAN: {
        url: '/sims/offersForOrganization'
    },
    SIM_UUID_PLAN: {
        url: '/sims/offersForSim',
        queryKey: 'getOffersForSim'
    },
    SIM_PLAN_UPDATE: {
        url: '/sims/changeOffer'
    },
    SIM_PLAN_LIST_TO_UPDATE: {
        url: '/sims/listOffersToUpdate',
        queryKey: 'simPlanListToUpdate'
    },
    PROVIDERS: {
        url: '/simProviders',
        query: 'simProviders'
    }
};
export const SIMS_GROUP = {
    COLLECTION: {
        url: '/simPools',
        queryKey: 'simGroups'
    },
    DETAILS: {
        url: '/simPool/:simPoolUuid',
        queryKey: 'simGroupDetails'
    },
    EXPORT_GROUPS: {
        url: '/simPools/export'
    }
};
export const SIM_ORDER_MAIL = {
    DETAILS: {
        url: '/sim/order'
    }
};
export const AUTOCOMPLETE = {
    DETAILS: {
        url: 'https://api-adresse.data.gouv.fr/search/?',
        queryKey: 'apiAddress'
    }
};
export default SIM_CARDS;